<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class="w-[500px]"
      />
    </div>
    <div class="flex flex-col items-center justify-center w-full h-full bg-white mt-2.5 md:mt-6.5">
      <div
        v-if="list.length === 0"
        class="flex flex-col sm:w-[520px] h-mx-auto"
      >
        <div class="grid grid-cols-1 gap-4 p-2 min-h-screen">
          <div class="flex flex-col justify-center items-center">
            <img src="@/assets/imgs/undraw_people_ka7y2.svg" alt="">
            <span class="flex justify-center items-center text-lg font-normal text-center my-6">
              No tienes prospectos agregados, te invitamos a que agregues a tus prospectos
            </span>
            <router-link
              :to="{ name: 'leads-add' }"
              class="flex items-center text-sm font-medium space-x-2 text-white bg-tuin-100 hover:bg-tuin_hover p-2 rounded-lg"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 5.5C10.2652 5.5 10.5196 5.60536 10.7071 5.79289C10.8946 5.98043 11 6.23478 11 6.5V9.5H14C14.2652 9.5 14.5196 9.60536 14.7071 9.79289C14.8946 9.98043 15 10.2348 15 10.5C15 10.7652 14.8946 11.0196 14.7071 11.2071C14.5196 11.3946 14.2652 11.5 14 11.5H11V14.5C11 14.7652 10.8946 15.0196 10.7071 15.2071C10.5196 15.3946 10.2652 15.5 10 15.5C9.73478 15.5 9.48043 15.3946 9.29289 15.2071C9.10536 15.0196 9 14.7652 9 14.5V11.5H6C5.73478 11.5 5.48043 11.3946 5.29289 11.2071C5.10536 11.0196 5 10.7652 5 10.5C5 10.2348 5.10536 9.98043 5.29289 9.79289C5.48043 9.60536 5.73478 9.5 6 9.5H9V6.5C9 6.23478 9.10536 5.98043 9.29289 5.79289C9.48043 5.60536 9.73478 5.5 10 5.5Z" fill="white"/>
              </svg>
              <span class="ml-2">Agregar</span>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else class="w-full max-w-6xl">
        <div class="flex flex-col sm:flex-row justify-end items-center gap-2 mt-4">
          <div ref="dropdownRef" class="relative">
            <button
              class="flex items-center group px-5 py-2.5 text-sm font-medium border border-tuin-100 rounded-lg text-tuin-100 bg-white hover:bg-tuin_hover hover:text-white transition-colors"
              @click="showDropdown = !showDropdown"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5 0C5.26522 0 5.51957 0.105357 5.70711 0.292893C5.89464 0.48043 6 0.734784 6 1V4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289C9.89464 4.48043 10 4.73478 10 5C10 5.26522 9.89464 5.51957 9.70711 5.70711C9.51957 5.89464 9.26522 6 9 6H6V9C6 9.26522 5.89464 9.51957 5.70711 9.70711C5.51957 9.89464 5.26522 10 5 10C4.73478 10 4.48043 9.89464 4.29289 9.70711C4.10536 9.51957 4 9.26522 4 9V6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H4V1C4 0.734784 4.10536 0.48043 4.29289 0.292893C4.48043 0.105357 4.73478 0 5 0Z" class="fill-tuin-100 group-hover:fill-white"/>
              </svg>
              <span class="ml-2">Agregar Prospecto</span>
            </button>
            <div
              v-if="showDropdown"
              class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg z-10 py-1"
            >
              <button
                class="w-full text-left px-4 py-2 text-sm font-medium text-custom_gray hover:text-tuin-100 hover:bg-gray-50 flex items-center gap-2"
                @click="addProspect('new'); showDropdown = false"
              >
                Manual
              </button>
              <button
                class="hidden sm:flex w-full text-left px-4 py-2 text-sm font-medium text-custom_gray hover:text-tuin-100 hover:bg-gray-50 items-center gap-2"
                @click="OpenMassModal(); showDropdown = false"
              >
                Alta masiva
              </button>
            </div>
          </div>
        </div>
        <div class="bg-white mt-4 sm:mt-6 w-full">
          <KanbanBoard 
            :leads="list" 
            :statuses="statuses"
            @lead-click="handleLeadClick"
            @status-updated="handleStatusUpdated"
          />
        </div>
      </div>
    </div>

    <AddMassLeadsModal
      v-if="mostrarMassModal"
      @close="CloseMassModal"
    />
  </div>
</template>

<script setup>
import KanbanBoard from "@/components/leads/KanbanBoard.vue";
import AddMassLeadsModal from "@/components/leads/Modal/AddMassLeadsModal.vue";

import axios from "axios";
import { ref, onMounted, onUnmounted, computed } from "vue";
import { useRouter } from "vue-router";

import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
let session = computed(() => store.getters.getUserSession);

let loader = ref(false);
let list = ref([]);
const statuses = [
  { name: 'Pendiente de contactar', status: '1' },
  { name: 'En proceso', status: '2' },
  { name: 'Finalizado', status: '3' },
  { name: 'No aplica', status: '4' },
  { name: 'Perdido', status: '5' },
  { name: 'Descartado', status: '6' },
];

let mostrarModal = ref(false);
let mostrarMassModal = ref(false);
let showDropdown = ref(false);
let dropdownRef = ref(null);

function handleClickOutside(event) {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    showDropdown.value = false;
  }
}


function addProspect(action, prospect_id) {
  if (action == "new") {
    router.push({ name: 'leads-add' });
    return;
  }
  
  if (action == "edit") {
    router.push({ name: 'leads-detail', params: { prospect_id } });
    return;
  }

  mostrarModal.value = true;
}

function CloseMassModal() {
  mostrarMassModal.value = false;
}

function OpenMassModal () {
  mostrarMassModal.value = true
}

function handleLeadClick(lead) {
  addProspect('edit', lead.id);
}

function handleStatusUpdated({ leadId, newStatusId }) {
  // Actualizar el estado local del lead
  const leadIndex = list.value.findIndex(lead => lead.id === leadId);
  if (leadIndex !== -1) {
    // Buscar el objeto status correspondiente
    const newStatus = statuses.find(status => status.status === newStatusId);
    if (newStatus) {
      list.value[leadIndex].status = {
        id: newStatusId,
        name: newStatus.name
      };
    }
  }
}

/*function ModalConfirmDelete() {
  console.log("debe confirmar la eliminación");
}*/

async function getLeads() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/leads/${session.value.id}`,
      options
    );

    if (response.status == 401) {
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      list.value = response.data.resp;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }

  loader.value = false;
}

onMounted(async () => {
  loader.value = true;
  document.addEventListener('click', handleClickOutside);
  await getLeads();
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>
.icon-svg {
  font-size: #fff;
}
</style>
